<template>
  <section
    id="interactive-card"
    class="container mx-auto px-2 sm:px-4 py-6 sm:py-8 lg:px-10"
  >
    <div
      class="bg-white border border-gray-200 shadow rounded-2xl p-4 sm:p-6 flex flex-col gap-4 transition"
    >
      <div
        class="flex flex-col sm:flex-row items-start sm:items-center gap-3 sm:gap-4"
      >
        <div
          class="flex-shrink-0 flex items-center justify-center w-12 h-12 sm:w-14 sm:h-14 rounded-xl bg-green-50 mb-2 sm:mb-0"
        >
          <v-icon
            :name="safeIconName('md-book')"
            class="text-green-500 text-2xl sm:text-3xl"
          />
        </div>
        <div class="flex-1 min-w-0 w-full">
          <div
            class="flex flex-col sm:flex-row items-start sm:items-center gap-1 sm:gap-2 w-full"
          >
            <h2
              class="text-lg sm:text-xl font-bold text-gray-900 flex-1 w-full sm:w-auto"
            >
              {{ data.title }}
            </h2>
            <a
              :href="`https://wp.homero.app.br/wp-admin/admin.php?page=h5p_new&id=${h5pId}`"
              target="_blank"
              class="text-gray-400 hover:text-h-primary-500 transition mt-1 sm:mt-0"
              aria-label="Editar"
            >
              <v-icon
                :name="safeIconName('bi-pencil-square')"
                class="text-lg sm:text-xl"
              />
            </a>
          </div>

          <div
            class="flex flex-wrap items-center gap-x-4 gap-y-2 text-xs sm:text-sm text-gray-500 mt-3"
          >
            <div class="flex items-center gap-1">
              <v-icon
                :name="safeIconName('md-access-time')"
                class="text-base"
              />
              <span>
                {{ formatDuration(data.duration) + " de atividades" }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <hr class="my-2 border-gray-100" />
      <div
        class="flex flex-col sm:flex-row flex-wrap items-start sm:items-center justify-between gap-2"
      >
        <div
          class="flex flex-col sm:flex-row items-start sm:items-center gap-2 sm:gap-3 w-full sm:w-auto"
        >
          <span
            class="bg-green-100 text-green-700 text-xs font-semibold px-3 py-1 rounded-full w-max"
            >{{ "Livro Interativo" }}</span
          >
          <span class="text-xs text-gray-400">
            {{ "Última atualização: " + formattedUpdatedAt }}
          </span>
        </div>
        <a
          :href="`https://wp.homero.app.br/wp-admin/admin.php?page=h5p&task=show&id=${h5pId}`"
          target="_blank"
          class="w-full sm:w-auto text-center bg-gradient-to-r bg-h-primary-500 text-white text-sm font-semibold px-5 py-2 rounded-lg shadow hover:opacity-80 transition"
        >
          {{ "Começar Leitura" }}
        </a>
      </div>
    </div>
  </section>
</template>

<script lang="ts" setup>
import { PropType, ref, computed } from "vue";
import { useRoute } from "vue-router";

const route = useRoute();
const h5pId = ref(route.params.h5pId || "");

const props = defineProps({
  data: {
    type: Object as PropType<any>,
    default: {},
  },
});

function formatDate(dateString: string): string {
  if (!dateString) return "";
  const date = new Date(dateString);
  const months = [
    "janeiro",
    "fevereiro",
    "março",
    "abril",
    "maio",
    "junho",
    "julho",
    "agosto",
    "setembro",
    "outubro",
    "novembro",
    "dezembro",
  ];
  const day = date.getDate();
  const month = months[date.getMonth()];
  const year = date.getFullYear();
  return `${day} de ${month}, ${year}`;
}

const formattedUpdatedAt = computed(() => formatDate(props.data.updatedAt));

function formatDuration(duration: string): string {
  if (!duration) return "";
  const [hours, minutes] = duration.split(":").map(Number);
  if (!isNaN(hours) && !isNaN(minutes)) {
    if (minutes > 0) return `${hours} horas e ${minutes} minutos`;
    else return `${hours} horas`;
  }
  return duration;
}

function safeIconName(name: string) {
  const validIcons = [
    "md-book",
    "bi-pencil-square",
    "md-access-time",
    "md-people",
    "md-star",
  ];
  return validIcons.includes(name) ? name : "md-book";
}
</script>
